module.exports = __webpack_public_path__ + "static/media/attraction2.785565f2.jpg";